import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  position: relative;\n  display: block;\n  @keyframes pulse {\n    50% {\n      opacity: 0.5;\n    }\n  }\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  background-size: cover;\n  background-repeat: repeat;\n"])), function (_ref) {
  var height = _ref.height;
  return height;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
});